import React, { Component } from 'react';
import { connect } from 'react-redux';
import JurisLogo from './JurisLogo';
import Arrow from '../assets/Arrow.gif';
import smoothScroll from 'smoothscroll';

import LocaleToggle from './LocaleToggle';

class JurisHeader extends Component {

    handleClick(e) {
        e.preventDefault();
        smoothScroll(document.querySelector("#services"));
    }

    render() {
        return (
            <header className="juris-header text-center row" id="header">

                <div className="header-inner dark-bg">
                    <div className="locale-toggle-container">
                        <LocaleToggle />
                    </div>

                    <div className="logo-container">
                        <a href="#services" onClick={this.handleClick}>
                           <JurisLogo />
                        </a>
                        <p className="logo-subtitle">{ this.props.subtitle }</p>
                    </div>

                    <div className="header-phone">
                        <p>
                            { this.props.phone }<br />
                            { this.props.fax }
                        </p>
                    </div>

                    <div className="arrow bottom">
                        <a href="#services" onClick={this.handleClick}>
                            <img src={Arrow} role="presentation" />
                        </a>
                    </div>
                </div>

            </header>
        )
    }
}

const mapStateToProps = ({ currentLocale, dictionaries }) => ({
    subtitle: dictionaries[ currentLocale ].header.subtitle || "",
    phone: dictionaries[ currentLocale ].header.phone || "",
    fax: dictionaries[ currentLocale ].header.fax || ""
});

export default connect( mapStateToProps )( JurisHeader );



/** WEBPACK FOOTER **
 ** ./src/components/JurisHeader.jsx
 **/